<article class="courses-sub-domain-container">
  <div class="courses-sub-domain">
    <app-course-side-menu></app-course-side-menu>
    <div class="sub-domain"><router-outlet></router-outlet></div>
  </div>
</article>
